<template>
  <b-container fluid class="px-0">
    <div class="position-relative content-div">
      <!-- MODAL Premium -->
      <PremiumModalComponent 
        :customerInfo="customerInfo" 
        :id="id" 
        :premiumCardsData="premiumCardsData" 
        :customerLastSubscription="customerLastSubscription"
        :showFreeContent="showFreeContent"
      />
      <PremiumTopOffer />
      <PremiumCategoriesCards 
        v-on:navigate="navigate($event)" 
        :customerInfo="customerInfo"/>
      <component
          :is="contentComponent"
          @updated="contentUpdated"
          :customerInfo="customerInfo"
          :premiumCardsData="premiumCardsData"
          :id="id"
          :customerLastSubscription="customerLastSubscription"
      />
    </div>
  </b-container>
</template>

<script>
import PremiumModalComponent from '@/components/centre/premium/PremiumModalComponent.vue';
import PremiumTopOffer from "@/components/centre/premium/PremiumTopOffer.vue";
import PremiumCategoriesCards from "@/components/centre/premium/PremiumCategoriesCards.vue";
import PremiumShowAllCards from "@/components/centre/premium/PremiumShowAllCards.vue";

import calendarImg from "@/assets/images/centre/premium/premia-offers/2023Calendar.png";
import masterclassKcImg from "@/assets/images/centre/premium/premia-offers/Masterclass_Kc.png";
import comingSoon2Img from "@/assets/images/centre/premium/premia-offers/ComingSoon2.png";
import comingSoon3Img from "@/assets/images/centre/premium/premia-offers/ComingSoon3.png";
import comingSoon4Img from "@/assets/images/centre/premium/premia-offers/ComingSoon4.png";
// import exclusiveWorkshopImg from "@/assets/images/centre/premium/premia-offers/ExclusiveWorkshop.png";
import giftCardsImg from "@/assets/images/centre/premium/premia-offers/GiftCards.png";
// import joyHolidayGiftImg from "@/assets/images/centre/premium/premia-offers/JoyHolidayGift.png";
import TheUltimateGuideToGCAnalysis from "@/assets/images/centre/premium/premia-offers/TheUltimateGuideToGCAnalysis.png";
import ModernCosmeticsBookGift from "@/assets/images/centre/premium/premia-offers/ModernCosmeticsBookGift.png";
// import ModernCosmetics from "@/assets/images/centre/perks/perks-modal/ModernCosmetics.jpg";
import ModernCosmeticsImgModal from "@/assets/images/centre/premium/premium-modal/Modern-cosmetics-book-Gift-Pop-up.png";
import CalendarImgModal from "@/assets/images/centre/premium/premium-modal/2023-Calendar-Pop-up.png";
// import ExclusiveWorkshopImgModal from "@/assets/images/centre/premium/premium-modal/Exclusive-Workshop-Pop-up.png";
import GiftCardsImgModal from "@/assets/images/centre/premium/premium-modal/Gift-Cards-Pop-up.png";
import DressToProgressImg from "@/assets/images/centre/premium/premia-offers/dress-to-progress.png";
import vDayCheatSheet from "@/assets/images/centre/premium/premia-offers/Dropsmart-V-day-cheat-sheet.png";



export default {
  title: "Center Premium",
  name: "Premium",
  props: ["page", "customerInfo", "id", "customerLastSubscription", "showFreeContent"],
  components: {
    PremiumModalComponent,
    PremiumTopOffer,
    PremiumCategoriesCards,
    PremiumShowAllCards,
  },
  watch: {
    showFreeContent: {
      handler () {
        console.log("Free Content: " + this.showFreeContent)
      },
      immediate: true
    }
  },
  mounted() {
    let target = this.page ? this.page : "PremiumShowAllCards";
    console.log("navigating to " + target);
    this.navigate(target);
  },
  data() {
    return {
      content: null,
      // categories possible by now: Masterclasses / SpecialGuests / SeasonalGifts
      premiumAllCardsData: [
        {
          id: 1,
          hasModal: true,
          category: "SeasonalGifts",
          productTitle: "Gift Cards",
          cardDescription: "Get your 1140 Euros worth of Dropsmart gift cards!",
          description: "Get your 1140 Euros worth of Dropsmart gift cards!",
          cardImage: giftCardsImg,
          image: GiftCardsImgModal,
          videoUrl: "",
          leftButton: "Click to download your PDF Dropsmart gift cards",
          linkDownload: "https://files.ontraport.com/media/b0286a678b3a4e5b8299980dd2c838e6.phpz76xbo?Expires=1829401182&Signature=PMTUHspgKejJX3AFT2KtOuxz7hSwyCiAtiYIrsGxmy7c~jTt3jtb9YZmTjxdGg6DlZ7tSFxWWMGXFOim6RVBn1zkcaBRTL98xwCuNSykwkatHB~gAGAVyaXVxIELixQYgY1ywi15ifYvS8ijRkV3tXiQEr0mEaMh38F~O2cgLq6rP~6eXy~oXao5P4gmtTUf9X7iLwWJzZOH3-UYebX0jNSM4k9m09oIlEEa~gmRGfiX~aDEn8ZW3R8h-T4byVxPtbjBjF7FI8a4vbYsp7k5Y-sh40uXHwrywxzw3koFP8uPqmPSp9U6NFefop6gVWcsX3l6IxVqEm2zhQ~qGorG0Q__&Key-Pair-Id=APKAJVAAMVW6XQYWSTNA",
          rightButton: "Share your comment",
          showOnDeck: false,
        },
        {
          id: 2,
          hasModal: false,
          category: "SeasonalGifts",
          productTitle: "Exclusive Workshop",
          cardDescription: "Save your spot to this exclusive one-time event!",
          description: "Save your spot to this exclusive one-time event!",
          cardImage: "",
          image: "",
          videoUrl: "",
          leftButton: "",
          linkDownload: "https://expo.dropsmart.io/janine-asmar/dress-to-progress",
          rightButton: "Share your comment",
          showOnDeck: false,
        },
        {
          id: 3,
          hasModal: true,
          category: "SpecialGuests",
          productTitle: "The ultimate guide to GC analysis",
          cardDescription: "Exclusive interview with Benoit Roger, Ph. D.",
          description: "Exclusive interview with Benoit Roger, Ph. D.",
          cardImage: TheUltimateGuideToGCAnalysis,
          image: "",
          videoUrl: "https://player.vimeo.com/video/771117044",
          leftButton: "",
          linkDownload: "",
          rightButton: "Share your comment",
          showOnDeck: true,
        },
        {
          id: 4,
          hasModal: true,
          category: "SeasonalGifts",
          productTitle: "Modern Cosmetics Gift",
          cardDescription: "50 pages of fantastic info on natural cosmetic ingredients.",
          description: "50 pages of fantastic info on natural cosmetic ingredients.",
          cardImage: ModernCosmeticsBookGift,
          image: ModernCosmeticsImgModal,
          videoUrl: "",
          leftButton: "Click to download your gift",
          linkDownload: "https://dropsmart.io/wp-content/uploads/2024/12/Modern-CosmEthics-50-page-book.pdf",
          rightButton: "Share your comment",
          showOnDeck: true,
        },
        {
          id: 5,
          hasModal: true,
          category: "SeasonalGifts",
          productTitle: "2023 Calendar",
          cardDescription: "Download & take advantage of all the fantastic events.",
          description: "Download & take advantage of all the fantastic events.",
          cardImage: calendarImg,
          image: CalendarImgModal,
          videoUrl: "",
          leftButton: "",
          linkDownload: "",
          rightButton: "Share your comment",
          showOnDeck: false,
        },
        {
          id: 6,
          hasModal: true,
          category: "Masterclasses",
          productTitle: "Clarify to Amplify",
          cardDescription: "How to create more impact and profits in less time with Business & Leadership Coach Kc Rossi",
          description: "How to create more impact and profits in less time with Business & Leadership Coach Kc Rossi",
          cardImage: masterclassKcImg,
          image: "",
          videoUrl: "https://player.vimeo.com/video/800159875",
          leftButton: "",
          linkDownload: "",
          rightButton: "Share your comment",
          showOnDeck: true,
        },
        {
          id: 7,
          hasModal: false,
          category: "Masterclasses",
          productTitle: "Coming Soon!",
          cardDescription: "Your summer complimentary masterclass.",
          description: "Your summer complimentary masterclass.",
          cardImage: comingSoon2Img,
          image: "",
          videoUrl: "",
          leftButton: "",
          linkDownload: "",
          rightButton: "",
          showOnDeck: false,
        },
        {
          id: 8,
          hasModal: false,
          category: "Masterclasses",
          productTitle: "Coming Soon!",
          cardDescription: "Your complimentary autumn masterclass.",
          description: "Surprise",
          cardImage: comingSoon3Img,
          image: "",
          videoUrl: "",
          leftButton: "",
          linkDownload: "",
          rightButton: "",
          showOnDeck: false,
        },
        {
          id: 9,
          hasModal: false,
          category: "Masterclasses",
          productTitle: "Coming Soon!",
          cardDescription: "Your spring complimentary masterclass.",
          description: "Surprise",
          cardImage: comingSoon4Img,
          image: "",
          videoUrl: "",
          leftButton: "",
          linkDownload: "",
          rightButton: "",
          showOnDeck: false,
        },
        {
          id: 10,
          hasModal: true,
          category: "SpecialGuests",
          productTitle: "Dress To Progress",
          cardDescription: "Workshop with internationally recognized fashion designer Janine Asmar",
          description: "Discover how your wardrobe improves your aromatherapy career and your personal life with Fashion Designer & Appearance Specialist Janine Asmar",
          cardImage: DressToProgressImg,
          image: "",
          videoUrl: "https://player.vimeo.com/video/790177648",
          leftButton: "",
          linkDownload: "",
          rightButton: "Share your comment",
          showOnDeck: true,
        },
        {
          id: 11,
          hasModal: true,
          category: "SeasonalGifts",
          productTitle: "Valentine's Day cheat sheet",
          cardDescription: "Show some extra love this V-Day! Download this cheat sheet.",
          description: "Show some extra love this V-Day! Download this cheat sheet.",
          cardImage: vDayCheatSheet,
          image: "",
          videoUrl: "https://player.vimeo.com/video/797297346",
          leftButton: "Click to download your gift",
          linkDownload: "https://dropsmart.io/wp-content/uploads/2024/12/Dropsmart-V-Day-Cheat-Sheet.pdf",
          rightButton: "Share your comment",
          showOnDeck: true,
        },
      ],
    };
  },
  computed: {
    contentComponent() {
      return this.content;
    },
    premiumCardsData() {
      return this.premiumAllCardsData.filter(function(u) {
        return u.showOnDeck;
      });
    },
  },
  methods: {
    navigate(routeName) {
      this.content = routeName;
    },
    contentUpdated() {
      this.customerInfo = JSON.parse(sessionStorage.getItem("customerInfo"));
    },
  },
};
</script>

<style scoped lang="scss">

</style>